<template>
  <div>
    <div class="alert alert-info">
      Kolom isian dengan tanda bintang (<span style="color: red">*</span>) adalah wajib untuk di isi. Maksimal memasukan 5 prestasi. <strong>{{messages}}</strong>
    </div>
    <center>
      <pulse-loader style="margin: 15px" :loading="loading" color="#696969" size="10px"></pulse-loader>
    </center>
    <div style="overflow-x: scroll">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th style="min-width: 40px" align="center">No</th>
            <th style="min-width: 200px" align="center">Nama Prestasi</th>
            <th style="min-width: 200px" align="center">Juara</th>
            <th style="min-width: 200px" align="center">Jenis Kompetisi</th>
            <th style="min-width: 200px" align="center">Tingkat</th>
            <th style="min-width: 200px" align="center">Jenis Kejuaraan</th>
            <th style="min-width: 200px" align="center">Tahun</th>
            <th style="min-width: 200px" align="center">Penyelenggara</th>
            <th style="min-width: 200px" align="center">Tanggal Mulai</th>
            <th style="min-width: 200px" align="center">Tanggal Selesai</th>
            <th style="min-width: 200px" align="center">Sertifikat</th>
            <th style="min-width: 200px" align="center">Aksi</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, n) in all" :key="item.id">
            <td>{{ n+1 }}</td>
            <td>{{item.nama_perlombaan}}</td>
            <td>{{ juara_ke(item.juara_ke) }}</td>
            <td>{{ jenis_kompetisi(item.jenis_kompetisi) }}</td>
            <td>{{ tingkat_kejuaraan(item.tingkat_kejuaraan) }}</td>
            <td>{{ jenis_kejuaraan(item.jenis_kejuaraan) }}</td>
            <td>{{item.tahun_penghargaan}}</td>
            <td>{{item.nama_penyelenggara}}</td>
            <td>{{item.tanggal_mulai}}</td>
            <td>{{item.tanggal_selesai}}</td>
            <td v-if="item.ext_sertifikat != null"><a :href="base + 'storage/docs/sertifikat_lomba_' + item.id_prestasi + '.' + item.ext_sertifikat" target="_blank">lihat dokumen</a></td>
            <td v-else>-</td>
            <td><a class="btn btn-danger" @click="() => { deleteData(item.id_prestasi) }">hapus</a></td>
          </tr>
        </tbody>
      </table>
    </div>
    <form class="form-horizontal form-space" onsubmit="return false">
      <div v-show="isExist('NM_PRES')" :class="{'form-group': true, 'has-error': errors.has('nama_perlombaan')}">
        <label class="col-md-3"><span class="required-label">*</span>Nama Prestasi</label>
        <div class="col-md-6">
          <input
            type="text"
            name="nama_perlombaan"
            placeholder="Nama Prestasi"
            class="form-control"
            maxlength="80"
            v-model="model.nama_perlombaan"
            v-validate="isExist('NM_PRES') ? 'required' : ''"
          >
          <span v-show="errors.has('nama_perlombaan')" class="error-label">Isi Nama Prestasi</span>
        </div>
      </div>
      <div v-show="isExist('JUARA')" :class="{'form-group': true, 'has-error': errors.has('juara_ke')}">
        <label class="col-md-3"><span class="required-label">*</span>Juara</label>
        <div class="col-md-4">
          <select
            type="text"
            name="juara_ke"
            class="form-control"
            v-model="model.juara_ke"
            v-validate="isExist('JUARA') ? 'required' : ''"
          >
            <option value="null" hidden>Pilih Juara</option>
            <option v-for="juara_ke in options.juara_ke" :key="juara_ke.id" :value="juara_ke.juara_ke">
              {{ juara_ke.nama_juara }}
            </option>
          </select>
          <span v-show="errors.has('juara_ke')" class="error-label">Pilih Juara</span>
        </div>
      </div>
      <div v-show="isExist('JENIS_KOM')" :class="{'form-group': true, 'has-error': errors.has('jenis_kompetisi')}">
        <label class="col-md-3"><span class="required-label">*</span>Jenis Kompetisi</label>
        <div class="col-md-4">
          <select
            type="text"
            name="jenis_kompetisi"
            class="form-control"
            v-model="model.jenis_kompetisi"
            v-validate="isExist('JENIS_KOM') ? 'required' : ''"
          >
            <option value="null" hidden>Pilih Jenis Kompetisi</option>
            <option v-for="jenis_kompetisi in options.jenis_kompetisi" :key="jenis_kompetisi.id" :value="jenis_kompetisi.jenis_kompetisi">
              {{ jenis_kompetisi.nama_kompetisi }}
            </option>
          </select>
          <span v-show="errors.has('jenis_kompetisi')" class="error-label">Pilih Jenis Kompetisi</span>
        </div>
      </div>
      <div v-show="isExist('TINGKAT')" :class="{'form-group': true, 'has-error': errors.has('tingkat_kejuaraan')}">
        <label class="col-md-3"><span class="required-label">*</span>Tingkat Kejuaraan</label>
        <div class="col-md-4">
          <select
            type="text"
            name="tingkat_kejuaraan"
            class="form-control"
            v-model="model.tingkat_kejuaraan"
            v-validate="isExist('TINGKAT') ? 'required' : ''"
          >
            <option value="null" hidden>Pilih Tingkat Kejuaraan</option>
            <option v-for="tingkat_kejuaraan in options.tingkat_kejuaraan" :key="tingkat_kejuaraan.id" :value="tingkat_kejuaraan.tingkat_kejuaraan">
              {{ tingkat_kejuaraan.nama_tingkat }}
            </option>
          </select>
          <span v-show="errors.has('tingkat_kejuaraan')" class="error-label">Pilih Jenis Kompetisi</span>
        </div>
      </div>
      <div v-show="isExist('JENIS_KEJ')" :class="{'form-group': true, 'has-error': errors.has('jenis_kejuaraan')}">
        <label class="col-md-3"><span class="required-label">*</span>Jenis Kejuaraan</label>
        <div class="col-md-4">
          <select
            type="text"
            name="jenis_kejuaraan"
            class="form-control"
            v-model="model.jenis_kejuaraan"
            v-validate="isExist('JENIS_KEJ') ? 'required' : ''"
          >
            <option value="null" hidden>Pilih Jenis Kejuaraan</option>
            <option v-for="jenis_kejuaraan in options.jenis_kejuaraan" :key="jenis_kejuaraan.id" :value="jenis_kejuaraan.jenis_kejuaraan">
              {{ jenis_kejuaraan.nama_kejuaraan }}
            </option>
          </select>
          <span v-show="errors.has('jenis_kejuaraan')" class="error-label">Pilih Jenis Kejuaraan</span>
        </div>
      </div>
      <div v-show="isExist('TAHUN')" :class="{'form-group': true, 'has-error': errors.has('tahun_penghargaan')}">
        <label class="col-md-3"><span class="required-label">*</span>Tahun</label>
        <div class="col-md-6">
          <input
            type="text"
            name="tahun_penghargaan"
            placeholder="Tahun"
            class="form-control"
            maxlength="10"
            v-model="model.tahun_penghargaan"
            v-validate="isExist('TAHUN') ? 'required' : ''"
          >
          <span v-show="errors.has('tahun_penghargaan')" class="error-label">Isi Tahun</span>
        </div>
      </div>
      <div v-show="isExist('PENYELENGGARA')" :class="{'form-group': true, 'has-error': errors.has('nama_penyelenggara')}">
        <label class="col-md-3"><span class="required-label">*</span>Penyelenggara</label>
        <div class="col-md-6">
          <input
            type="text"
            name="nama_penyelenggara"
            placeholder="Penyelenggara"
            class="form-control"
            maxlength="100"
            v-model="model.nama_penyelenggara"
            v-validate="isExist('PENYELENGGARA') ? 'required' : ''"
          >
          <span v-show="errors.has('nama_penyelenggara')" class="error-label">Isi Penyelenggara</span>
        </div>
      </div>
      <div v-if="isExist('WAKTU')" :class="{'form-group': true, 'has-error': errors.has('tanggal_mulai')}">
        <label class="col-md-3"><span class="required-label">*</span>Tanggal Mulai</label>
        <div class="col-md-4">
          <datetimepicker name="tanggal_mulai"
            format="YYYY/MM/DD"
            :value="this.model.tanggal_mulai"
            placeholder="Tanggal Mulai"
            v-validate="isExist('WAKTU') ? 'required' : ''"
            @update-date="updateTglMulai">
          </datetimepicker>
          <span v-show="errors.has('tanggal_mulai')" class="error-label">Isi Tanggal Mulai</span>
        </div>
      </div>
      <div v-if="isExist('WAKTU')" :class="{'form-group': true, 'has-error': errors.has('tanggal_selesai')}">
        <label class="col-md-3"><span class="required-label">*</span>Tanggal Selesai</label>
        <div class="col-md-4">
          <datetimepicker name="tanggal_selesai"
            format="YYYY/MM/DD"
            :value="this.model.tanggal_selesai"
            placeholder="Tanggal Selesai"
            v-validate="isExist('WAKTU') ? 'required' : ''"
            @update-date="updateTglSelesai">
          </datetimepicker>
          <span v-show="errors.has('tanggal_selesai')" class="error-label">Isi Tanggal Selesai</span>
        </div>
      </div>
      <div v-show="isExist('SERTIFIKAT')" class="form-group">
        <label class="col-md-3"><span class="required-label">*</span>Sertifikat</label>
        <div class="col-md-6">
          <el-upload
            class="upload-demo"
            ref="upload"
            :action="docEndPointSertifikat"
            :headers="header"
            name="sertifikat"
            :auto-upload="false"
            :data="dataUpload"
            :on-change="handleChange"
            :on-error="handleError"
            :on-success="handleSuccess"
            :limit="1"
            :on-exceed="handleExceed"
            :before-upload="beforeDocsUpload"
            :file-list="model.sertifikat_list"
            drag>
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
            <div class="el-upload__tip" slot="tip"><strong>Format pdf/jpg/png dan tidak boleh lebih dari 1 MB</strong></div>
          </el-upload>
        </div>
      </div>
    </form>
    <div class="alert alert-success">
      <p>Tekan tombol tambah untuk menambahkan data prestasi</p>
      <button class="btn btn-default" style="margin-top: 20px;" @click="sendData">Tambah</button>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { baseURL, base } from '@/api/data'
import DateTimePicker from '@/components/DateTimePicker'

export default {
  data () {
    return {
      init: false,
      all: [],
      loading: false,
      model: {
        nama_perlombaan: null,
        juara_ke: null,
        jenis_kompetisi: null,
        tingkat_kejuaraan: null,
        jenis_kejuaraan: null,
        tahun_penghargaan: null,
        nama_penyelenggara: null,
        tanggal_mulai: null,
        tanggal_selesai: null,
        sertifikat: [],
        sertifikat_list: []
      },
      options: {
        jenis_kompetisi: [
          {jenis_kompetisi: 'P', nama_kompetisi: 'Perorangan'},
          {jenis_kompetisi: 'R', nama_kompetisi: 'Beregu/Kelompok'}
        ],
        tingkat_kejuaraan: [
          {tingkat_kejuaraan: '01', nama_tingkat: 'Internasional'},
          {tingkat_kejuaraan: '02', nama_tingkat: 'Nasional'},
          {tingkat_kejuaraan: '03', nama_tingkat: 'Provinsi'},
          {tingkat_kejuaraan: '04', nama_tingkat: 'Kabupaten'},
          {tingkat_kejuaraan: '05', nama_tingkat: 'Kecamatan'},
          {tingkat_kejuaraan: '06', nama_tingkat: 'Desa/Kelurahan'},
          {tingkat_kejuaraan: '07', nama_tingkat: 'Lainnya'}
        ],
        jenis_kejuaraan: [
          {jenis_kejuaraan: '1001', nama_kejuaraan: 'PRESTASI ILMIAH - PIDATO BAHASA ASING'},
          {jenis_kejuaraan: '1002', nama_kejuaraan: 'PRESTASI ILMIAH - DEBAT BAHASA ASING'},
          {jenis_kejuaraan: '1003', nama_kejuaraan: 'PRESTASI ILMIAH - KARYA TULIS ILMIAH'},
          {jenis_kejuaraan: '1004', nama_kejuaraan: 'PRESTASI ILMIAH - OLIMPIADE'},
          {jenis_kejuaraan: '1005', nama_kejuaraan: 'PRESTASI OLAHRAGA - BADMINTON'},
          {jenis_kejuaraan: '1006', nama_kejuaraan: 'PRESTASI OLAHRAGA - TENIS MEJA'},
          {jenis_kejuaraan: '1007', nama_kejuaraan: 'PRESTASI OLAHRAGA - TENIS LAPANGAN'},
          {jenis_kejuaraan: '1008', nama_kejuaraan: 'PRESTASI OLAHRAGA - KARATE'},
          {jenis_kejuaraan: '1009', nama_kejuaraan: 'PRESTASI OLAHRAGA - PENCAK SILAT'},
          {jenis_kejuaraan: '1010', nama_kejuaraan: 'PRESTASI OLAHRAGA - BOLA VOLLY'},
          {jenis_kejuaraan: '1011', nama_kejuaraan: 'PRESTASI OLAHRAGA - FUTSAL'},
          {jenis_kejuaraan: '1012', nama_kejuaraan: 'PRESTASI OLAHRAGA - CATUR'},
          {jenis_kejuaraan: '1013', nama_kejuaraan: 'PRESTASI OLAHRAGA - PANJAT DINDING'},
          {jenis_kejuaraan: '1014', nama_kejuaraan: 'PRESTASI OLAHRAGA - ATLETIK'},
          {jenis_kejuaraan: '1015', nama_kejuaraan: 'PRESTASI KESENIAN - SENI RUPA'},
          {jenis_kejuaraan: '1016', nama_kejuaraan: 'PRESTASI KESENIAN - SENI MUSIK'},
          {jenis_kejuaraan: '1017', nama_kejuaraan: 'PRESTASI KESENIAN - SENI TARI'},
          {jenis_kejuaraan: '1018', nama_kejuaraan: 'PRESTASI KESENIAN - SENI MULTIMEDIA'},
          {jenis_kejuaraan: '1019', nama_kejuaraan: 'PRESTASI KEAGAMAAN - TILAWATUL QURAN'},
          {jenis_kejuaraan: '1020', nama_kejuaraan: 'PRESTASI KEAGAMAAN - HIFDZUL QURAN'},
          {jenis_kejuaraan: '1021', nama_kejuaraan: 'PRESTASI KEAGAMAAN - VOKALIS ISLAMI'},
          {jenis_kejuaraan: '1022', nama_kejuaraan: 'PRESTASI KEAGAMAAN - SENI DRAMA ISLAMI'},
          {jenis_kejuaraan: '1023', nama_kejuaraan: 'PRESTASI KEAGAMAAN - KALIGRAFI'},
          {jenis_kejuaraan: '1024', nama_kejuaraan: 'PRESTASI TAHFIDZ - TAHFIDZH'},
          {jenis_kejuaraan: '1025', nama_kejuaraan: 'PRESTASI LAINNYA - LAINNYA'}
        ],
        juara_ke: [
          {juara_ke: '1', nama_juara: '1'},
          {juara_ke: '2', nama_juara: '2'},
          {juara_ke: '3', nama_juara: '3'},
          {juara_ke: '4', nama_juara: 'Harapan 1'},
          {juara_ke: '5', nama_juara: 'Harapan 2'},
          {juara_ke: '6', nama_juara: 'Harapan 3'},
          {juara_ke: '7', nama_juara: 'Lainnya'}
        ]
      }
    }
  },
  updated () {
    this.$nextTick(function () {
      var elements = document.getElementsByClassName('el-upload__input')
      while (elements.length > 0) {
        elements[0].parentNode.removeChild(elements[0])
      }
    })
  },
  components: {
    'datetimepicker': DateTimePicker
  },
  computed: {
    base () {
      return base
    },
    header () {
      let token = localStorage.getItem('client-admisi-token')
      let headerAPI = {
        'Authorization': `Bearer ${token}`
      }
      return headerAPI
    },
    dataUpload () {
      let data = {nomor_pendaftar: this.nomorPendaftar, ...this.model}
      return data
    },
    nomorPendaftar () {
      return this.$store.getters.getAuthData.data.mhs_jalur.nomor_pendaftar
    },
    docEndPointSertifikat () {
      if (process.env.NODE_ENV !== 'test') {
        return baseURL + 'v2/prestasi_lomba_mahasiswa'
      } else {
        return 'test'
      }
    },
    messages () {
      let message = ''
      this.$store.getters.getMessages(11).forEach(item => {
        message = message + ' ' + item.note + '.'
      })
      return message
    }
  },
  methods: {
    validate () {
      return new Promise((resolve, reject) => {
        if (this.all.length > 0) {
          if (this.all.length > 5) {
            scroll(0, 0)
            this.flash('prestasi maksimal 5', 'error')
            resolve(false)  
          } else {
            resolve(true)
          }
        } else {
          scroll(0, 0)
          this.flash('tambahkan prestasi minimal 1', 'error')
          resolve(false)
        }
      })
    },
    validateForm () {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll()
          .then(valid => {
            if (valid) {
              let sertifikatUploaded = this.model.sertifikat.length > 0
              !sertifikatUploaded && this.isExist('SERTIFIKAT') ? reject({message: 'belum ada scan sertifikat'}) : false
              resolve(true)
            } else {
              reject({message: 'isian belum lengkap'})
            }
          })
      })
    },
    sendData () {
      this.validateForm()
        .then(valid => {
          this.$refs.upload.submit()
        })
        .catch(e => {
          this.flash(e.message, 'error')
          scroll(0, 0)
        })
    },
    isExist (name) {
      return this.$store.getters.formIsExist(name, 11)
    },
    initData () {
      if (!this.init) {
        this.getData()
        this.init = true
      }
    },
    updateTglMulai (date) {
      this.model.tanggal_mulai = date
    },
    updateTglSelesai (date) {
      this.model.tanggal_selesai = date
    },
    handleError (err, file, fileList) {
      if (process.env.NODE_ENV !== 'test') {
        let res = JSON.parse(err.message)
        alert(`upload error, ${res.message}`)
      } else {
        this.model.nama_perlombaan = null
        this.model.juara_ke = null
        this.model.jenis_kompetisi = null
        this.model.tingkat_kejuaraan = null
        this.model.jenis_kejuaraan = null
        this.model.tahun_penghargaan = null
        this.model.nama_penyelenggara = null
        this.model.tanggal_mulai = null
        this.model.tanggal_selesai = null
        this.model.sertifikat_list = []
        this.all.push({
          id_prestasi: 'test',
          nama_perlombaan: 'Test',
          juara_ke: '1',
          jenis_kompetisi: 'P',
          tingkat_kejuaraan: '01',
          jenis_kejuaraan: '1001',
          tahun_penghargaan: 'test',
          nama_penyelenggara: 'test',
          tanggal_mulai: 'test',
          tanggal_selesai: 'test',
          ext_sertifikat: 'test'
        })
        alert('upload sukses')
        scroll(0, 0)
      }
    },
    handleExceed () {
      alert('maksimal 1 file')
    },
    handleSuccess (res, file) {
      this.model.nama_perlombaan = null
      this.model.juara_ke = null
      this.model.jenis_kompetisi = null
      this.model.tingkat_kejuaraan = null
      this.model.jenis_kejuaraan = null
      this.model.tahun_penghargaan = null
      this.model.nama_penyelenggara = null
      this.model.tanggal_mulai = null
      this.model.tanggal_selesai = null
      this.model.sertifikat_list = []
      this.getData()
      this.getSertifikat(res.data.id_prestasi)
      alert('upload sukses')
      scroll(0, 0)
    },
    handleChange (file, fileList) {
      this.model.sertifikat = [{name: file.name}]
    },
    beforeDocsUpload (file) {
      const isMIME = file.type === 'application/pdf' || file.type === 'image/png' || file.type === 'image/jpeg'
      const isLt2M = file.size < 1000000
      !isMIME ? alert('Dokumen berformat pdf/jpg/png') : false
      !isLt2M ? alert('Dokumen tidak boleh lebih dari 1 MB') : false
      return isMIME && isLt2M
    },
    juara_ke (juaraKe) {
      return this.options.juara_ke.filter(e => e.juara_ke === juaraKe)[0].nama_juara
    },
    jenis_kompetisi (jenisKompetisi) {
      return this.options.jenis_kompetisi.filter(e => e.jenis_kompetisi === jenisKompetisi)[0].nama_kompetisi
    },
    tingkat_kejuaraan (tingkatKejuaraan) {
      return this.options.tingkat_kejuaraan.filter(e => e.tingkat_kejuaraan === tingkatKejuaraan)[0].nama_tingkat
    },
    jenis_kejuaraan (jenisKejuaraan) {
      return this.options.jenis_kejuaraan.filter(e => e.jenis_kejuaraan === jenisKejuaraan)[0].nama_kejuaraan
    },
    getData () {
      this.loading = true
      api.get('/v2/prestasi_lomba_mahasiswa/' + this.nomorPendaftar)
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            this.all = responseData.data
            this.model.sertifikat = []
            this.loading = false
          }
        })
        .catch(e => {
          this.loading = false
        })
    },
    getSertifikat (idPrestasi) {
      api.get('/v2/prestasi_lomba_mahasiswa/sertifikat/' + idPrestasi)
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            this.getData()
          }
        })
    },
    deleteData (idPrestasi) {
      if (process.env.NODE_ENV !== 'test') {
        api.delete('/v1/prestasi_lomba_mahasiswa/' + idPrestasi)
          .then(response => {
            let responseData = response.data
            if (responseData.success) {
              this.getData()
            }
          })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/page/register/DataPrestasi.vue